import React, { useState } from "react";
import "../../assets/css/agency.css";
import NavBar from "../../components/general/NavBarApp.jsx";
import AgencyMap from "../../components/agency/agencyMap.jsx";

const Agency = () => {
  return (
    <section className="agency-hero-section" id="agency-hero">
      <NavBar userType="interim" />
      <AgencyMap />
    </section>
  );
};

export default Agency;
